import { useParams } from 'react-router-dom'
import MonitoringReport, {
  type MonitoringReportProps
} from 'screens/Reports/MonitoringReports/components/MonitoringReport/MonitoringReport'
import { reportMappings } from './utils'

type ReportKey = keyof typeof reportMappings

const helpUrl =
  'https://support.logmycare.co.uk/en/articles/8428698-monitoring-reports'

const MonitoringReports = () => {
  const { report } = useParams()

  const reportProps: Omit<MonitoringReportProps, 'helpUrl'> =
    reportMappings[report as ReportKey] || reportMappings.fluids

  return (
    <MonitoringReport
      title={reportProps.title}
      description={reportProps.description}
      reportingId={reportProps.reportingId}
      aggregation={reportProps.aggregation}
      helpUrl={helpUrl}
    />
  )
}

export default MonitoringReports
